/* eslint-disable import/no-cycle */
import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import { StatusOperations } from 'const';
import { MODAL_CLOSE } from 'redux/slices/modals';
import { Button, Icon } from 'ui/atoms';
import { AccountRole } from 'ui/components';
import { Container } from 'ui/gridSystem';
import MainFont from 'ui/typography/mainFont';

import Modal, { stopEvent } from '../Modal';
import {
  ButtonsContainer,
  IconClose,
  ModalGlobalContainer,
  ModalTitle,
  ModalWrapper
} from '../Modal.style';
import { ModalContainer, ModalContent } from './style';

const modalId = 'PeopleModal';

const PeopleModal = ({ onClose, payload, targetRole }) => {
  const [header, setHeader] = useState('');
  const [message, setMessage] = useState('');
  const [successText, setSuccessText] = useState('');
  const [error, setError] = useState();
  const { count, onAccept, data, email, modalType, cognitoId } = payload || {};

  const { t } = useTranslation();

  useEffect(() => {
    if (modalType === StatusOperations.ENABLE) {
      setHeader(t('enable_account'));
      setMessage(
        t('status_confirmation_text_want', {
          operation: StatusOperations.ENABLE.toLocaleLowerCase(),
          count,
          item: count > 1 ? 'accounts' : 'account'
        })
      );
      setSuccessText(count > 1 ? t('enable_msg') : t('enable_msg_single'));
    } else if (modalType === StatusOperations.DISABLE) {
      setHeader(t('disable_account'));
      setMessage(
        t('status_confirmation_text', {
          operation: StatusOperations.DISABLE.toLocaleLowerCase(),
          count,
          item: count > 1 ? 'accounts' : 'account'
        })
      );
      setSuccessText(count > 1 ? t('disable_msg') : t('disable_msg_single'));
    } else if (modalType === StatusOperations.DELETE) {
      setHeader(t('delete_account'));
      setMessage(
        t('status_confirmation_text_want', {
          operation: StatusOperations.DELETE.toLocaleLowerCase(),
          count,
          item: count > 1 ? 'accounts' : 'account'
        })
      );
      setSuccessText(
        count > 1 ? t('delete_multiple_msg') : t('delete_single_msg')
      );
    } else if (modalType === StatusOperations.CHANGEROLE) {
      setHeader(t('change_role'));
      setMessage(
        t('change_role_text', {
          operation: StatusOperations.CHANGEROLE.toLocaleLowerCase(),
          count
        })
      );
      setSuccessText(t('confirm'));
    } else if (modalType === StatusOperations.RESEND_EMAIL) {
      setHeader(t('resend_email_header'));
      setMessage(
        t('resend_email_description', {
          email
        })
      );
      setSuccessText(t('resend_email_send_button'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count, modalType, email]);

  const handleConfirm = () => {
    if (modalType === StatusOperations.CHANGEROLE && !targetRole) {
      setError(true);
      return;
    }
    setError(false);
    if (modalType === StatusOperations.CHANGEROLE) {
      onAccept(modalType, targetRole);
    } else {
      onAccept(modalType, cognitoId);
    }
    onClose();
  };

  return (
    <Modal id={modalId}>
      <Container>
        <ModalWrapper>
          <ModalGlobalContainer onMouseDown={stopEvent} onClick={stopEvent}>
            <ModalTitle>
              <MainFont type="peopleModalHeader">{header}</MainFont>
              <IconClose>
                <Icon type="icon-close-modal" size={20} onClick={onClose} />
              </IconClose>
            </ModalTitle>
            <ModalContainer>
              <ModalContent popupType={modalType}>
                <MainFont type="peopleModalText">{message}</MainFont>
                {modalType === StatusOperations.CHANGEROLE ? (
                  <AccountRole selectedData={data} roleError={error} />
                ) : null}
              </ModalContent>
            </ModalContainer>
            <ButtonsContainer>
              <Button
                variant="popupCancel"
                buttonType="people_role_change"
                onClick={onClose}
              >
                {t('no_wait')}
              </Button>
              <Button
                variant="popupYes"
                type={modalType}
                onClick={handleConfirm}
                buttonType="people_role_change"
              >
                {successText}
              </Button>
            </ButtonsContainer>
          </ModalGlobalContainer>
        </ModalWrapper>
      </Container>
    </Modal>
  );
};

PeopleModal.id = modalId;

PeopleModal.propTypes = {
  onClose: PropTypes.func,
  payload: PropTypes.object,
  targetRole: PropTypes.string
};

export default connect(
  state => ({
    payload: state.modals?.payload,
    targetRole: state?.people?.targetRole
  }),
  dispatch => ({ onClose: () => dispatch(MODAL_CLOSE()) })
)(PeopleModal);
